import { toLowerCaseFirst } from '@pages/settings/helper';
import {
  dropdownPicklistsNames,
  picklistsActions,
  picklistSysNames
} from '@redux/slices/picklists/picklists-slice';
import { setClassNames } from '@components/tree-component';
import {
  createNestedArrayForAreaHierarchy,
  flattenArray,
  inspectionActions,
  showValueWithParents,
  sortAndReturnValue
} from '@redux/slices/inspection/inspection-slice';
import { getAppDispatch } from '@utilities/dispatch.util';

const picklistDataManipulationJson = ({ data }) => {
  const pickLists = data?.items || [];
  let picklistObjects = pickLists?.reduce((acc, curr) => {
    if (acc[curr.sysName]) {
      acc[curr.sysName].push({
        ...curr
      });
    } else {
      acc[curr.sysName] = [
        {
          ...curr
        }
      ];
    }
    return acc;
  }, {});

  let list = [],
    dropdownList = [];

  for (let foo of picklistSysNames) list.push({ [foo]: picklistObjects[foo] || [] });

  for (let foo of dropdownPicklistsNames)
    dropdownList = {
      ...dropdownList,
      [`${toLowerCaseFirst(foo)}`]: picklistObjects[foo] || []
    };

  let dropdownValue = [
    'SiteStatus',
    'CodeOfConstruction',
    'Province',
    'EquipmentCategory',
    'EquipmentStatus',
    'Service',
    'PSVType',
    'Pressure',
    'Volume',
    'Temperature',
    'SmallMeasurement',
    'PipelineStatus',
    'Substance',
    'AreaHierarchy',
    'EquipmentConnectionType',
    'InspectionFrequency',
    'OrientationType'
  ];

  const equipmentCategoryTypeAndSubTypeDropdownPickListsName = [
    'EquipmentCategory',
    'EquipmentType',
    'EquipmentSubType'
  ];

  const picklists = {},
    dropdownMap = {},
    equipmentCategoryTypeAndSubTypeDropdownMap = {};

  list.forEach((pickListData, i) => {
    if (
      dropdownValue?.includes(picklistSysNames[i]) &&
      pickListData[picklistSysNames[i]]?.length > 0
    )
      dropdownMap[`${toLowerCaseFirst(picklistSysNames[i])}`] = pickListData[picklistSysNames[i]];

    if (
      equipmentCategoryTypeAndSubTypeDropdownPickListsName?.includes(picklistSysNames[i]) &&
      pickListData[picklistSysNames[i]]?.length > 0
    )
      equipmentCategoryTypeAndSubTypeDropdownMap[`${toLowerCaseFirst(picklistSysNames[i])}`] =
        pickListData[picklistSysNames[i]];

    if (pickListData[picklistSysNames[i]]?.length > 0)
      picklists[`${toLowerCaseFirst(picklistSysNames[i])}Data`] = pickListData[picklistSysNames[i]];
  });

  const arr = [];
  //   let picklistsMap = {};
  const { areaHierarchyData = [] } = picklists;

  const areaHierarchyTreeDataMap = areaHierarchyData
    .map(({ key, value, parentKey }) => ({ key, title: value, parentKey }))
    .reduce((acc, curr) => {
      acc[curr.key] = { ...curr, children: [] };
      return acc;
    }, {});

  for (const key in areaHierarchyTreeDataMap) {
    if (Object.hasOwnProperty.call(areaHierarchyTreeDataMap, key)) {
      const curr = areaHierarchyTreeDataMap[key];
      if (areaHierarchyTreeDataMap[curr.parentKey])
        areaHierarchyTreeDataMap[curr.parentKey].children.push(areaHierarchyTreeDataMap[key]);
    }
  }

  for (const key in areaHierarchyTreeDataMap) {
    if (Object.hasOwnProperty.call(areaHierarchyTreeDataMap, key)) {
      const curr = areaHierarchyTreeDataMap[key];
      if (!curr.parentKey) arr.push(curr);
    }
  }

  const areaHierarchyDataMap = areaHierarchyData?.reduce((acc, curr) => {
    acc[curr?.key] = curr?.value;
    return acc;
  }, {});

  const newDropdownMap = {};
  Object.keys(dropdownMap)?.map((key) => {
    if (key === 'areaHierarchy') {
      const list = createNestedArrayForAreaHierarchy(dropdownMap[key], null);
      newDropdownMap[key] = [...list];
    } else {
      const list = dropdownMap[key]
        ?.slice()
        ?.sort((a, b) => a?.sortOrder - b?.sortOrder)
        .map((x) => {
          if (key === 'equipmentCategory') {
            return {
              label: x?.value || '',
              value: x?.key || '',
              allowedForPSVCreation: x?.allowedForPSVCreation || false,
              allowedForPVCreation: x?.allowedForPVCreation || false
            };
          } else {
            return {
              label: x?.value || '',
              value: x?.key || ''
            };
          }
        });
      newDropdownMap[key] = [...list];
      if (key === 'equipmentCategory') {
        newDropdownMap['psvCategoryTypeAndSubType'] = (dropdownMap['equipmentCategory'] || [])
          ?.filter((item) => item?.allowedForPSVCreation)
          .map((item) => {
            return {
              label: item?.value || '',
              value: item?.key || ''
            };
          });
      }
    }
  });

  const equipmentCategoryTypeAndSubTypeDropdown = [
    equipmentCategoryTypeAndSubTypeDropdownMap?.equipmentCategory || [],
    equipmentCategoryTypeAndSubTypeDropdownMap?.equipmentType || [],
    equipmentCategoryTypeAndSubTypeDropdownMap?.equipmentSubType || []
  ]?.flat(1);

  let equipmentCategoryTypeAndSubType = createNestedArrayForAreaHierarchy(
    equipmentCategoryTypeAndSubTypeDropdown,
    null,
    true
  );

  equipmentCategoryTypeAndSubType = showValueWithParents(equipmentCategoryTypeAndSubType, null);
  let equipmentCategoryTypeAndSubTypeMap = flattenArray(equipmentCategoryTypeAndSubType, []);
  equipmentCategoryTypeAndSubTypeMap = equipmentCategoryTypeAndSubTypeMap?.reduce((acc, curr) => {
    acc[curr.key] = curr.showValue;
    return acc;
  }, {});
  const equipmentCategoryTypeSubtype = equipmentCategoryTypeAndSubType;
  // const equipmentCategoryTypeAndSubTypeMap = equipmentCategoryTypeAndSubTypeMap;

  let sortedInspectionDropdownList = {};

  Object.keys(dropdownList)?.map((listIns) => {
    sortedInspectionDropdownList = {
      ...sortedInspectionDropdownList,
      [listIns]: sortAndReturnValue({
        list: dropdownList[listIns]
      })
    };
    return listIns;
  });

  // Object.keys(dropdownMap)?.map((listIns) => {
  //   sortedInspectionDropdownList = {
  //     ...sortedInspectionDropdownList,
  //     [listIns]: sortAndReturnValue({
  //       list: dropdownMap[listIns]
  //     })
  //   };
  //   return listIns;
  // });

  return {
    inspectionDropdownList: dropdownList,
    picklists,
    dropdownMap,
    equipmentCategoryTypeAndSubTypeDropdownMap,
    areaHierarchyDataMap,
    areaHierarchyTreeData: setClassNames(arr),
    areaHierarchyTreeDataMap: areaHierarchyTreeDataMap,
    newDropdownMap,
    equipmentCategoryTypeAndSubTypeDropdown,
    equipmentCategoryTypeSubtype,
    equipmentCategoryTypeAndSubTypeMap,
    sortedInspectionDropdownList
  };
};

const picklistDataDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  if (Object.keys(data?.picklists).length)
    dispatch?.(
      picklistsActions.setPicklistsNew({
        pickLists: data?.picklists,
        areaHierarchyDataMap: data?.areaHierarchyDataMap,
        areaHierarchyTreeData: data?.areaHierarchyTreeData,
        areaHierarchyTreeDataMap: data?.areaHierarchyTreeDataMap
      })
    );

  if (Object.keys(data?.newDropdownMap).length)
    dispatch?.(
      inspectionActions.setInspectionFormMenuDropdownAsPicklistsNew({
        newDropdownMap: data?.newDropdownMap
      })
    );
  if (Object.keys(data?.equipmentCategoryTypeAndSubTypeDropdownMap).length) {
    dispatch?.(
      inspectionActions.setEquipmentCategoryTypeAndSubTypeDropdownNew({
        equipmentCategoryTypeAndSubType: data?.equipmentCategoryTypeSubtype,
        equipmentCategoryTypeAndSubTypeMap: data?.equipmentCategoryTypeAndSubTypeMap
      })
    );
  }

  if (data?.sortedInspectionDropdownList) {
    dispatch?.(
      inspectionActions.setInspectionFormMenuDropdownNew(data?.sortedInspectionDropdownList)
    );
  }
};

const mobileUsersDataManipulationJson = ({ data }) => {
  const usersList = data?.items || [];
  return (
    usersList.map((x) => {
      return {
        label: `${x?.firstName} ${x?.lastName}`,
        value: x?.userId || ''
      };
    }) || []
  );
};

const mobileUsersDataDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();
  const usersList = data || [];
  dispatch?.(inspectionActions.setUsersNamesList(usersList));
};

export {
  picklistDataManipulationJson,
  picklistDataDispatcher,
  mobileUsersDataManipulationJson,
  mobileUsersDataDispatcher
};
